// extracted by mini-css-extract-plugin
export default {"paymentNetwork":"PaymentNetwork_paymentNetwork__ZxMjt","noMerchantAccount":"PaymentNetwork_noMerchantAccount__5rZ8i","noMerchantMessage":"PaymentNetwork_noMerchantMessage__z35KM"};